module.exports = __webpack_public_path__ + "img/skysupport.724a7237.png";